<template>
  <div>
    <v-row class="px-4">
      <v-col cols="12">
        <h3 class="pa-0">{{title}}</h3>
      </v-col>
      <v-col cols="6">
        <EyecatcherItem
          :title="item.title"
          :message="item.subtitle"
          :image="item.image"
          item="item"
          @click="clickEyecatcher(item)"
          v-for="(item, index) in leftitem"
          :key="index"
        ></EyecatcherItem>
      </v-col>
      <v-col cols="6">
        <EyecatcherItem
          :title="item.title"
          :message="item.subtitle"
          :image="item.image"
          item="item"
          @click="clickEyecatcher(item)"
          v-for="(item, index) in rightitem"
          :key="index"
          colored
        ></EyecatcherItem>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { firebase } from "../../main";
import EyecatcherItem from "../design/EyecatcherItem";

export default {
  data() {
    return {
      eyecatcher: [],
    };
  },
  mounted() {
    firebase
      .firestore()
      .collection("products")
      .where("eyecatcher", "==", "1")
      .where("highlight", "==", "0")
      .orderBy("sortorder", "desc")
      .limit(2)
      .onSnapshot((docs) => {
        docs.forEach((doc) => {
          this.$set(this.eyecatcher, this.eyecatcher.length, doc.data());
        });
      });
    firebase
      .firestore()
      .collection("services")
      .where("eyecatcher", "==", "1")
      .orderBy("sortorder", "desc")
      .limit(2)
      .onSnapshot((docs) => {
        docs.forEach((doc) => {
          this.$set(this.eyecatcher, this.eyecatcher.length, doc.data());
        });
      });
  },
  methods: {
    clickEyecatcher(item) {
      if (item.hasOwnProperty("url")) {
        window.open(item.url, "_blank");
      }
    },
  },
  computed: {
    leftitem: function () {
      return this.eyecatcher.slice(0, 1);
    },
    rightitem: function () {
      return this.eyecatcher.slice(1, 2);
    },
  },
  props: {
    title: String,
    left: Object,
    right: Object,
  },
  components: {
    EyecatcherItem,
  },
};
</script>